/**
 * 自定义组件注册配置
 * 包含所有自定义组件的注册逻辑
 */

import Vue from 'vue';

// 自定义组件（按字母顺序排列）
import DsAutoAudit from '@/components/DsAutoAudit';
import DsCascader from '@/components/Cascader';
import DsCustomer from '@/components/Customer';
import DsInput from '@/components/DsInput';
import DsQuestion from '@/components/Question';
import DsTooltip from '@/components/DsTooltip';
import siderDialog from '@/components/otherDialog/siderDialog';

// 组件列表（按字母顺序排列）
const components = [
    { name: 'DsAutoAudit', component: DsAutoAudit },
    { name: 'DsCascader', component: DsCascader },
    { name: 'DsCustomer', component: DsCustomer },
    { name: 'DsInput', component: DsInput },
    { name: 'DsQuestion', component: DsQuestion },
    { name: 'DsTooltip', component: DsTooltip }
];

// 注册所有组件
export function registerComponents() {
    components.forEach(({ name, component }) => {
        Vue.use(component);
    });

    // 注册全局组件
    Vue.component('siderDialog', siderDialog);
}
